import React from "react";
import "./carousel.css";
import logoQemu from "../../assets/qemu-logo.png";
import logoCisco from "../../assets/cisco-logo.svg";
import logoWG from "../../assets/wireguard-logo.svg";
import logoVMware from "../../assets/vmware-logo.svg";
import logoMsAD from "../../assets/ms-ad-logo.svg";
import logoGLPI from "../../assets/glpi-logo.svg";
import logovSphere from "../../assets/vsphere-logo.png";
import logoGrafana from "../../assets/grafana-logo.svg";
import logoZ from "../../assets/zabbix-logo.svg";
import logoOPNsense from "../../assets/opnsense-logo.png";
import logoDeb from "../../assets/debian-logo.svg";
import logoWinSrv from "../../assets/win-server-logo.svg";
import logopfSense from "../../assets/pfsense-logo.png";
const logos = [
  `${logoQemu}`,
  `${logoCisco}`,
  `${logoGLPI}`,
  `${logoMsAD}`,
  `${logovSphere}`,
  `${logoGrafana}`,
  `${logoWG}`,
  `${logoVMware}`,
  `${logoZ}`,
  `${logoOPNsense}`,
  `${logoDeb}`,
  `${logoWinSrv}`,
  `${logopfSense}`,
];

const Carousel = () => {
  return (
    <div className="carousel">
      {logos.map((logo, index) => (
        <div
          key={index}
          className="carousel__face"
          style={{ "--rotate": `${index * (360 / logos.length)}deg` }}
        >
          <img src={logo} alt="logo" />
        </div>
      ))}
    </div>
  );
};

export default Carousel;
